import { EmptyState, PageHead, useHelpScreen } from '@hive/ui';
import { Link } from 'react-router';
import { useT } from '../i18n';

export function NotFound() {
  useHelpScreen('not-found');
  const t = useT();
  return (
    <>
      <PageHead title={t('notFound.title')} />
      <EmptyState
        title={t('notFound.text')}
        action={
          <Link className="btn btn-primary" to="/">
            {t('notFound.home')}
          </Link>
        }
      />
    </>
  );
}

/** A tela não está disponível para o perfil ativo (o menu já a esconde; isto cobre links diretos). */
export function Denied({ profile }: { profile: string }) {
  const t = useT();
  return (
    <EmptyState title={t('denied.title')} action={<Link className="btn" to="/">{t('notFound.home')}</Link>}>
      {t('perm.denied', { profile })} {t('perm.ask')}
    </EmptyState>
  );
}
